export const FormErrorMessage = (props: { message: string }): JSX.Element => (
  <span className="form-text m-b-none text-start ps-3 text-danger">
    {props.message}
  </span>
);
